import InputField from "../../components/Auth/InputField";
import useTranslator from "../../hooks/useTranslator";
import { PhoneInput } from "react-international-phone";

const LLBasicInfo = ({
  title,
  subtitle,
  userLogin,
  onChangeHandler,
  setUserLogin,
  submitHandler,
}) => {
  const { _t } = useTranslator();
  return (
    <>
      <form
        onSubmit={submitHandler}
        className="formInformation passwordFormInfo"
      >
        <h2>{title}</h2>
        <p>{subtitle}</p>
        <div className="d-flex create-account-input">
          <InputField
            name={"fname_companyName"}
            isHalf={true}
            value={userLogin?.fname_companyName ?? ""}
            label={"firstName"}
            onChange={onChangeHandler}
            onBeforeInput={(e) => {
              const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
              if (!isValidChar) e.preventDefault();
            }}
          />
          <InputField
            name={"lname"}
            isHalf={true}
            value={userLogin?.lname ?? ""}
            label={"lastName"}
            onChange={onChangeHandler}
            onBeforeInput={(e) => {
              const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
              if (!isValidChar) e.preventDefault();
            }}
          />
        </div>
        <div className="forminput customInput">
          <h6 className="modal-label mb-0">{_t("phoneNumber")}</h6>
          <PhoneInput
            className="phone_input_info"
            international
            defaultCountry={"es"}
            value={userLogin?.phone}
            inputProps={{
              required: true,
            }}
            onChange={(e) =>
              setUserLogin((prev) => ({
                ...prev,
                phone: e?.replace("+", "") || "",
              }))
            }
          />
        </div>
        <button type="submit" className="btnNext basicInfoButton greenHover">
          {_t("submit")}
        </button>
      </form>
    </>
  );
};
export default LLBasicInfo;
